import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { SocketProvider } from './contexts/SocketContext';
import Home from './pages/Home';
import Admin from './pages/Admin';
import Presentation from './pages/Presentation';
import TeamJoin from './pages/TeamJoin';
import TeamPlay from './pages/TeamPlay';
import QuestionManager from './pages/QuestionManager';

function App() {
  return (
    <SocketProvider>
      <Router>
        <div className="app">
          <Routes>
            {/* Home - choose role */}
            <Route path="/" element={<Home />} />
            
            {/* Admin/Mol panel - create and control game */}
            <Route path="/admin" element={<Admin />} />
            <Route path="/admin/:gameId" element={<Admin />} />
            <Route path="/admin/vragen" element={<QuestionManager />} />
            
            {/* Presentation screen - for big screen */}
            <Route path="/scherm/:gameId" element={<Presentation />} />
            
            {/* Team screens */}
            <Route path="/join" element={<TeamJoin />} />
            <Route path="/join/:gameId" element={<TeamJoin />} />
            <Route path="/play/:gameId/:teamId" element={<TeamPlay />} />
          </Routes>
        </div>
      </Router>
    </SocketProvider>
  );
}

export default App;
